import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./filterSection.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { PopoverHorizontalOrientation, PopoverVerticalOrientation } from 'wds/popover';
import { WireI18n, i18nStore } from '~/modules/stores/i18nStore';
import { DeviceType, selectDeviceType, viewportStore } from '~/modules/stores/viewportStore';
const OPENED_TOGGLE_CLASS = 'toggle-section-icon opened';
const CLOSED_TOGGLE_CLASS = 'toggle-section-icon closed';
const OPENED_CONTENT_CLASS = 'section-content opened';
const CLOSED_CONTENT_CLASS = 'section-content closed';
class FilterSectionComponent extends LightningElement {
  constructor(...args) {
    super(...args);
    this._section = void 0;
    this._opened = 'OPEN';
    this.container = void 0;
    this.starsLabel = void 0;
    this.deviceType = void 0;
  }
  set section(section) {
    if (section.toggleDefault !== undefined) {
      this._opened = section.toggleDefault ? 'OPEN' : 'CLOSED';
    } else {
      this._opened = 'OPEN';
    }
    this._section = section;
  }
  get section() {
    return this._section;
  }
  get opened() {
    return this._opened === 'OPEN';
  }
  get toggleClass() {
    return this.opened ? OPENED_TOGGLE_CLASS : CLOSED_TOGGLE_CLASS;
  }
  get popoverOrientation() {
    if (this.section.name === 'impact') {
      if (this.section.tooltipPlacement === 'top') {
        return {
          vertical: PopoverVerticalOrientation.TOP,
          horizontal: PopoverHorizontalOrientation.RIGHT
        };
      }
      return {
        vertical: PopoverVerticalOrientation.TOP,
        horizontal: PopoverHorizontalOrientation.CENTER
      };
    }
    return null;
  }
  get contentClass() {
    return this.opened ? OPENED_CONTENT_CLASS : CLOSED_CONTENT_CLASS;
  }
  get isLocationType() {
    return this.section.type === 'location';
  }
  get isMultiLevelType() {
    return this.section.type === 'multiLevel';
  }
  get isBaseType() {
    return this.section.type == null;
  }
  get sectionOptions() {
    return this.section?.options || [];
  }
  handleOptionChange(event) {
    event.stopPropagation();
    this.dispatchEvent(new CustomEvent('filterchange', {
      detail: {
        section: this.section.name,
        value: event.detail.value
      },
      composed: true,
      bubbles: true,
      cancelable: true
    }));
  }
  handleAnalytics(event) {
    event.detail.section = this.section.name;
    event.detail.sectionLabel = this.section.label;
  }
  handleToggleSectionClick() {
    this._opened = this._opened === 'OPEN' ? 'CLOSED' : 'OPEN';
  }
  get toggleLabel() {
    return i18nStore.getState().i18n.search.filters.filterSectionToggleAriaLabel({
      sectionLabel: this.section.label
    });
  }
  get starsLabels() {
    if (this.section.noLabeledStars) {
      return '';
    }
    return this.starsLabel;
  }
  get hasSectionToggle() {
    return !this.section.noSectionToggle;
  }
  get sectionTitleContainerClass() {
    return this._section.tooltip ? 'section-title-container tooltip' : 'section-title-container';
  }
  get showBottomTooltip() {
    return this._section.tooltipPlacement === 'bottom';
  }
  get showTopTooltip() {
    return !!this._section.tooltip && this._section.tooltipPlacement === 'top';
  }
  get tooltipLabel() {
    return this._section.tooltipLabel;
  }
  get sectionContainer() {
    return this.container === 'explore' && this.deviceType === DeviceType.DESKTOP ? '' : 'section-container';
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(FilterSectionComponent, {
  publicProps: {
    container: {
      config: 0
    },
    section: {
      config: 3
    }
  },
  track: {
    _section: 1
  },
  wire: {
    starsLabel: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: i18n => i18n.search.filters.starsLabel
        };
      }
    },
    deviceType: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: viewportStore,
          selector: selectDeviceType
        };
      }
    }
  },
  fields: ["_opened"]
});
const __lwc_component_class_internal = _registerComponent(FilterSectionComponent, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;